import {StyledCustomTooltip} from "./style";

export default StyledCustomTooltip